module.exports = __webpack_public_path__ + "static/media/book4_1.9002ce71.jpg";